export const FETCH_AGENT_RESPONDER_STARTED = 'FETCH_AGENT_RESPONDER_STARTED';
export const FETCH_AGENT_RESPONDER_SUCCEEDED = 'FETCH_AGENT_RESPONDER_SUCCEEDED';
export const FETCH_AGENT_RESPONDER_FAILED = 'FETCH_AGENT_RESPONDER_FAILED';
export const fetchAgentResponderStarted = requestArgs => ({
  type: FETCH_AGENT_RESPONDER_STARTED,
  payload: {
    requestArgs
  }
});
export const fetchAgentResponderSucceeded = ({
  requestArgs,
  data
}) => ({
  type: FETCH_AGENT_RESPONDER_SUCCEEDED,
  payload: {
    requestArgs,
    data
  }
});
export const fetchAgentResponderFailed = requestArgs => ({
  type: FETCH_AGENT_RESPONDER_FAILED,
  payload: {
    requestArgs
  }
});